import React from 'react';
import PropTypes from 'prop-types';

import { FormConsumer } from '../Form';

class ProductRadio extends React.Component {
  onChange = (e) => {
    const { value, fieldName } = this.props;

    this.props.setValue(fieldName, value);

    if (typeof this.props.onChange !== 'undefined') {
      this.props.onChange(fieldName, value);
    }
  };

  render() {
    const {
      fieldName,
      value,
      name,
      image,
      price,
      values,
    } = this.props;

    const fieldId = `${fieldName}-${value}`;

    return (
      <article className="column mtm-radio">
        <input
          id={fieldId}
          type="radio"
          name={fieldName}
          value={value}
          checked={(typeof values[fieldName] !== 'undefined' && values[fieldName] === value) || false}
          onChange={this.onChange}
        />
        <label htmlFor={fieldId}>
          <figure dangerouslySetInnerHTML={{ __html: image }} />

          <div className="mtm-radio-inner">
            <h4 className="mtm-product-name">{name}</h4>
            {price && <div className="mtm-product-price">{price}</div>}
            <div className="mtm-check"><i className="icon-check"></i></div>
          </div>
        </label>
      </article>
    );
  }
}

ProductRadio.propTypes = {
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  price: PropTypes.node,
  values: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
  onChange: PropTypes.func,
};

export default function(props) {
  return (
    <FormConsumer>
      {({ values, setValue, errors }) => (
        <ProductRadio {...props} values={values} setValue={setValue} />
      )}
    </FormConsumer>
  );
}



// WEBPACK FOOTER //
// ./src/ProductRadio/index.js